import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ModalWrapper from '../../base/modals/modal-wrapper';

import './styles/create-collection-modal.scss';

const creationTypes = ['manual', 'automated'];

const CreateCollectionModal = ({ setShowModal }) => {
  const [creationType, setCreationType] = useState(creationTypes[0]);

  return (
    <div className="create-collection-modal">
      <ModalWrapper closeModal={() => setShowModal(false)}>
        <h1>Create a Collection</h1>
        <h3>Highlight products for Publishers by creating collections.</h3>
        <div className="radio-items">
          <h2>Add Products...</h2>
          <div className="radio-item" onClick={() => setCreationType(creationTypes[0])}>
            <span className={`icon ${creationType === creationTypes[0] ? 'selected' : ''}`}>
              <span className="fill"></span>
            </span>
            <div className="label-description">
              <label>Manually</label>
              <div className="description">Add products to this collection one by one.</div>
            </div>
          </div>
          <div className="radio-item" onClick={() => setCreationType(creationTypes[1])}>
            <span className={`icon ${creationType === creationTypes[1] ? 'selected' : ''}`}>
              <span className="fill"></span>
            </span>
            <div className="label-description">
              <label>Automatically</label>
              <div className="description">
                Automatically generate a collection of products by setting conditions. This
                collection will update the product listings based on the conditions set.
              </div>
            </div>
          </div>
        </div>
        <div className="btns">
          <button className="cancel-btn" onClick={() => setShowModal(false)}>
            Cancel
          </button>
          <Link to={`/v2/admin/collections/create/${creationType}`}>
            <button className="next-btn">Next</button>
          </Link>
        </div>
      </ModalWrapper>
    </div>
  );
};

export default CreateCollectionModal;
